import { View } from '../View/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoResults = ({
  isLoading,
  error,
  totalOptions,
  noResultsText
}) => {
  if (!isLoading && !error && totalOptions === 0) {
    return /*#__PURE__*/_jsx(View, {
      paddingBlock: "200",
      paddingInline: "300",
      children: noResultsText
    });
  }
  return null;
};